import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {}

  canActivate(): boolean {
    if (!this.authService.isGlobalAdmin) {
      this.snackBar.open('Access denied. Global Admin privileges required.', 'OK', { duration: 3000 });
      this.router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}
